__turbopack_context__.v({
  "helios-grid": "LTC3bW_helios-grid",
  "helios-grid--collapse-lg": "LTC3bW_helios-grid--collapse-lg",
  "helios-grid--collapse-md": "LTC3bW_helios-grid--collapse-md",
  "helios-grid--collapse-sm": "LTC3bW_helios-grid--collapse-sm",
  "helios-grid--columns-1": "LTC3bW_helios-grid--columns-1",
  "helios-grid--columns-12": "LTC3bW_helios-grid--columns-12",
  "helios-grid--columns-2": "LTC3bW_helios-grid--columns-2",
  "helios-grid--columns-3": "LTC3bW_helios-grid--columns-3",
  "helios-grid--columns-4": "LTC3bW_helios-grid--columns-4",
  "helios-grid--columns-base-1": "LTC3bW_helios-grid--columns-base-1",
  "helios-grid--columns-base-12": "LTC3bW_helios-grid--columns-base-12",
  "helios-grid--columns-base-2": "LTC3bW_helios-grid--columns-base-2",
  "helios-grid--columns-base-3": "LTC3bW_helios-grid--columns-base-3",
  "helios-grid--columns-base-4": "LTC3bW_helios-grid--columns-base-4",
  "helios-grid--columns-lg-1": "LTC3bW_helios-grid--columns-lg-1",
  "helios-grid--columns-lg-12": "LTC3bW_helios-grid--columns-lg-12",
  "helios-grid--columns-lg-2": "LTC3bW_helios-grid--columns-lg-2",
  "helios-grid--columns-lg-3": "LTC3bW_helios-grid--columns-lg-3",
  "helios-grid--columns-lg-4": "LTC3bW_helios-grid--columns-lg-4",
  "helios-grid--columns-md-1": "LTC3bW_helios-grid--columns-md-1",
  "helios-grid--columns-md-12": "LTC3bW_helios-grid--columns-md-12",
  "helios-grid--columns-md-2": "LTC3bW_helios-grid--columns-md-2",
  "helios-grid--columns-md-3": "LTC3bW_helios-grid--columns-md-3",
  "helios-grid--columns-md-4": "LTC3bW_helios-grid--columns-md-4",
  "helios-grid--columns-sm-1": "LTC3bW_helios-grid--columns-sm-1",
  "helios-grid--columns-sm-12": "LTC3bW_helios-grid--columns-sm-12",
  "helios-grid--columns-sm-2": "LTC3bW_helios-grid--columns-sm-2",
  "helios-grid--columns-sm-3": "LTC3bW_helios-grid--columns-sm-3",
  "helios-grid--columns-sm-4": "LTC3bW_helios-grid--columns-sm-4",
  "helios-grid--columns-xl-1": "LTC3bW_helios-grid--columns-xl-1",
  "helios-grid--columns-xl-12": "LTC3bW_helios-grid--columns-xl-12",
  "helios-grid--columns-xl-2": "LTC3bW_helios-grid--columns-xl-2",
  "helios-grid--columns-xl-3": "LTC3bW_helios-grid--columns-xl-3",
  "helios-grid--columns-xl-4": "LTC3bW_helios-grid--columns-xl-4",
  "helios-grid--gap-lg": "LTC3bW_helios-grid--gap-lg",
  "helios-grid--gap-md": "LTC3bW_helios-grid--gap-md",
  "helios-grid--gap-none": "LTC3bW_helios-grid--gap-none",
  "helios-grid--gap-sm": "LTC3bW_helios-grid--gap-sm",
  "helios-grid--gap-xl": "LTC3bW_helios-grid--gap-xl",
  "helios-grid--ruled": "LTC3bW_helios-grid--ruled",
  "helios-grid__item": "LTC3bW_helios-grid__item",
  "helios-grid__item--span-1": "LTC3bW_helios-grid__item--span-1",
  "helios-grid__item--span-10": "LTC3bW_helios-grid__item--span-10",
  "helios-grid__item--span-11": "LTC3bW_helios-grid__item--span-11",
  "helios-grid__item--span-12": "LTC3bW_helios-grid__item--span-12",
  "helios-grid__item--span-2": "LTC3bW_helios-grid__item--span-2",
  "helios-grid__item--span-3": "LTC3bW_helios-grid__item--span-3",
  "helios-grid__item--span-4": "LTC3bW_helios-grid__item--span-4",
  "helios-grid__item--span-5": "LTC3bW_helios-grid__item--span-5",
  "helios-grid__item--span-6": "LTC3bW_helios-grid__item--span-6",
  "helios-grid__item--span-7": "LTC3bW_helios-grid__item--span-7",
  "helios-grid__item--span-8": "LTC3bW_helios-grid__item--span-8",
  "helios-grid__item--span-9": "LTC3bW_helios-grid__item--span-9",
  "helios-grid__item--span-base-1": "LTC3bW_helios-grid__item--span-base-1",
  "helios-grid__item--span-base-10": "LTC3bW_helios-grid__item--span-base-10",
  "helios-grid__item--span-base-11": "LTC3bW_helios-grid__item--span-base-11",
  "helios-grid__item--span-base-12": "LTC3bW_helios-grid__item--span-base-12",
  "helios-grid__item--span-base-2": "LTC3bW_helios-grid__item--span-base-2",
  "helios-grid__item--span-base-3": "LTC3bW_helios-grid__item--span-base-3",
  "helios-grid__item--span-base-4": "LTC3bW_helios-grid__item--span-base-4",
  "helios-grid__item--span-base-5": "LTC3bW_helios-grid__item--span-base-5",
  "helios-grid__item--span-base-6": "LTC3bW_helios-grid__item--span-base-6",
  "helios-grid__item--span-base-7": "LTC3bW_helios-grid__item--span-base-7",
  "helios-grid__item--span-base-8": "LTC3bW_helios-grid__item--span-base-8",
  "helios-grid__item--span-base-9": "LTC3bW_helios-grid__item--span-base-9",
  "helios-grid__item--span-lg-1": "LTC3bW_helios-grid__item--span-lg-1",
  "helios-grid__item--span-lg-10": "LTC3bW_helios-grid__item--span-lg-10",
  "helios-grid__item--span-lg-11": "LTC3bW_helios-grid__item--span-lg-11",
  "helios-grid__item--span-lg-12": "LTC3bW_helios-grid__item--span-lg-12",
  "helios-grid__item--span-lg-2": "LTC3bW_helios-grid__item--span-lg-2",
  "helios-grid__item--span-lg-3": "LTC3bW_helios-grid__item--span-lg-3",
  "helios-grid__item--span-lg-4": "LTC3bW_helios-grid__item--span-lg-4",
  "helios-grid__item--span-lg-5": "LTC3bW_helios-grid__item--span-lg-5",
  "helios-grid__item--span-lg-6": "LTC3bW_helios-grid__item--span-lg-6",
  "helios-grid__item--span-lg-7": "LTC3bW_helios-grid__item--span-lg-7",
  "helios-grid__item--span-lg-8": "LTC3bW_helios-grid__item--span-lg-8",
  "helios-grid__item--span-lg-9": "LTC3bW_helios-grid__item--span-lg-9",
  "helios-grid__item--span-md-1": "LTC3bW_helios-grid__item--span-md-1",
  "helios-grid__item--span-md-10": "LTC3bW_helios-grid__item--span-md-10",
  "helios-grid__item--span-md-11": "LTC3bW_helios-grid__item--span-md-11",
  "helios-grid__item--span-md-12": "LTC3bW_helios-grid__item--span-md-12",
  "helios-grid__item--span-md-2": "LTC3bW_helios-grid__item--span-md-2",
  "helios-grid__item--span-md-3": "LTC3bW_helios-grid__item--span-md-3",
  "helios-grid__item--span-md-4": "LTC3bW_helios-grid__item--span-md-4",
  "helios-grid__item--span-md-5": "LTC3bW_helios-grid__item--span-md-5",
  "helios-grid__item--span-md-6": "LTC3bW_helios-grid__item--span-md-6",
  "helios-grid__item--span-md-7": "LTC3bW_helios-grid__item--span-md-7",
  "helios-grid__item--span-md-8": "LTC3bW_helios-grid__item--span-md-8",
  "helios-grid__item--span-md-9": "LTC3bW_helios-grid__item--span-md-9",
  "helios-grid__item--span-sm-1": "LTC3bW_helios-grid__item--span-sm-1",
  "helios-grid__item--span-sm-10": "LTC3bW_helios-grid__item--span-sm-10",
  "helios-grid__item--span-sm-11": "LTC3bW_helios-grid__item--span-sm-11",
  "helios-grid__item--span-sm-12": "LTC3bW_helios-grid__item--span-sm-12",
  "helios-grid__item--span-sm-2": "LTC3bW_helios-grid__item--span-sm-2",
  "helios-grid__item--span-sm-3": "LTC3bW_helios-grid__item--span-sm-3",
  "helios-grid__item--span-sm-4": "LTC3bW_helios-grid__item--span-sm-4",
  "helios-grid__item--span-sm-5": "LTC3bW_helios-grid__item--span-sm-5",
  "helios-grid__item--span-sm-6": "LTC3bW_helios-grid__item--span-sm-6",
  "helios-grid__item--span-sm-7": "LTC3bW_helios-grid__item--span-sm-7",
  "helios-grid__item--span-sm-8": "LTC3bW_helios-grid__item--span-sm-8",
  "helios-grid__item--span-sm-9": "LTC3bW_helios-grid__item--span-sm-9",
  "helios-grid__item--span-xl-1": "LTC3bW_helios-grid__item--span-xl-1",
  "helios-grid__item--span-xl-10": "LTC3bW_helios-grid__item--span-xl-10",
  "helios-grid__item--span-xl-11": "LTC3bW_helios-grid__item--span-xl-11",
  "helios-grid__item--span-xl-12": "LTC3bW_helios-grid__item--span-xl-12",
  "helios-grid__item--span-xl-2": "LTC3bW_helios-grid__item--span-xl-2",
  "helios-grid__item--span-xl-3": "LTC3bW_helios-grid__item--span-xl-3",
  "helios-grid__item--span-xl-4": "LTC3bW_helios-grid__item--span-xl-4",
  "helios-grid__item--span-xl-5": "LTC3bW_helios-grid__item--span-xl-5",
  "helios-grid__item--span-xl-6": "LTC3bW_helios-grid__item--span-xl-6",
  "helios-grid__item--span-xl-7": "LTC3bW_helios-grid__item--span-xl-7",
  "helios-grid__item--span-xl-8": "LTC3bW_helios-grid__item--span-xl-8",
  "helios-grid__item--span-xl-9": "LTC3bW_helios-grid__item--span-xl-9",
});
